import React, { useState, useEffect } from "react";
import { Layout, Menu, Affix, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import LogoOriginal from "../img/logo.png";
import { Link } from "react-router-dom";
const { Header } = Layout;

export const NavDesarrollo = () => {
  const [isDrawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);

      if (window.innerWidth > 1024) {
        setDrawerVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    closeDrawer();
  };

  const menuItems = [
    { key: "1", label: <a href="/">Inicio</a> },
    { key: "2", label: <a href="/infraestructura">Infraestructura</a> },
    {
      key: "3",
      label: <a onClick={() => handleScroll("servicios")}>Servicios</a>,
    },
    {
      key: "4",
      label: (
        <a onClick={() => handleScroll("asistentesVirtuales")}>
          Asistentes virtuales
        </a>
      ),
    },
    {
      key: "5",
      label: <a onClick={() => handleScroll("casosExito")}>Casos de éxito</a>,
    },
    {
      key: "6",
      label: <a onClick={() => handleScroll("partners")}>Partners</a>,
    },
    {
      key: "7",
      label: <a onClick={() => handleScroll("contacto")}>Contacto</a>,
    },
  ];

  return (
    <Affix>
      <Header className="navbar-desarrollo">
        <div className="logo">
          <Link to="/">
            <img src={LogoOriginal} alt="Logo" />
          </Link>
        </div>

        {/* Menú para escritorio */}
        {!isMobile && (
          <div className="menu-desktop">
            <Menu mode="horizontal" items={menuItems} />
          </div>
        )}

        {/* Menú para teléfono */}
        {isMobile && (
          <div className="menu-mobile">
            <Button
              type="text"
              icon={<MenuOutlined className="icono-menu-mobile" />}
              onClick={showDrawer}
            />
          </div>
        )}

        {/* Drawer para teléfono */}
        <Drawer placement="right" onClose={closeDrawer} open={isDrawerVisible}>
          <Menu mode="vertical" items={menuItems} onClick={closeDrawer} />
        </Drawer>
      </Header>
    </Affix>
  );
};
